import { render } from "./ProfileBranchNew.vue?vue&type=template&id=1876504d&scoped=true"
import script from "./ProfileBranchNew.vue?vue&type=script&lang=js"
export * from "./ProfileBranchNew.vue?vue&type=script&lang=js"

import "./ProfileBranchNew.vue?vue&type=style&index=0&id=1876504d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1876504d"]])

export default __exports__